function ErrorMessage(): JSX.Element {
  return (
    <div className="sign-in__message">
      <p>Please enter a valid email address</p>
    </div>
  );
}

export default ErrorMessage;
